import ApiInstance from "./ApiInstance";

export interface Slot {
  start: string; // ISO
  end: string;
}

class SchedulingApi {
  async slots(psychologistId: string, type: string, days = 14): Promise<Slot[]> {
    const { data } = await ApiInstance.getApi().get(`/scheduling/${psychologistId}/slots`, {
      params: { type, days },
    });
    return data.slots;
  }
  async getMyAvailability(): Promise<{ weeklyBlocks: any[]; exceptions: string[] }> {
    const { data } = await ApiInstance.getApi().get("/scheduling/me/availability");
    return data;
  }
  async setMyAvailability(body: { weeklyBlocks: any[]; exceptions: string[] }): Promise<void> {
    await ApiInstance.getApi().put("/scheduling/me/availability", body);
  }
}

const schedulingApi = new SchedulingApi();
export default schedulingApi;
